import { ref } from '@vue/composition-api'
import { PrinterConnection } from '@yonarezi/yonarezi3.epos-printer'
import useCurrentData from '@/views/composable/useCurrentData'
import { removePortFromIpAddress } from '@/utils/removePortFromIpAddress'
import { reportPrinterError } from '@/utils/sentryReportPrinterError'
import useReceiptPrinterDeviceSetting from '@/views/composable/useReceiptPrinterDeviceSetting'

export default () => {
  const { currentClub } = useCurrentData()
  const { isDisabled: isPrinterDisabledOnThisDevice } = useReceiptPrinterDeviceSetting()

  const isConnected = ref(null)
  const isConnecting = ref(null)
  const printer = ref(null)

  const checkConnection = async (printIpAddress = null, { force = false } = {}) => {
    // 端末側で「プリンタを使わない」設定されている場合は接続試行をスキップ
    // (店舗の他端末との接続キュー詰まりを防ぐため、印刷を担当しない端末は接続しないようにする)
    // force = true の場合はスキップせず接続を試す (設定画面の「接続テスト」用)
    if (isPrinterDisabledOnThisDevice.value && !force) {
      isConnecting.value = false
      isConnected.value = false
      printer.value = null

      return
    }

    isConnecting.value = true

    let ipAddress = printIpAddress
    if (!ipAddress) {
      ipAddress = currentClub.value.printIpAddress
    }
    ipAddress = removePortFromIpAddress(ipAddress)

    try {
      const printerConnection = new PrinterConnection({ ipAddress })
      printer.value = await printerConnection.connect()
      isConnected.value = !!printer.value.ePosDev.isConnected()
    } catch (error) {
      console.error(error)
      reportPrinterError(error, {
        kind: 'receipt',
        phase: 'connect',
        ipAddress,
        clubId: currentClub.value?.id,
      })
    } finally {
      isConnecting.value = false
    }
  }

  return {
    // data
    isConnected,
    isConnecting,
    printer,
    isPrinterDisabledOnThisDevice,

    // methods
    checkConnection,
  }
}
